/*
 * fonctions spécifiques au formulaire de programme
 */
if( $('#frm_programme').get().length ) {

	// ajout fournisseur
	$('._addfournisseur').click(function() {
		var $this = $(this);
		var $target = $this.is('[data-target]') ? $($this.data('target')) : $this.next();
		if( $('#frm_fournisseurs').val() != '' ) {
			var html = '<div class="_toParseFournisseur _toremove image_thumb document_thumb" data-iteration="{{iteration}}"><textarea class="_toParse_value" name="' + $this.data('name') + '">' + $('#frm_fournisseurs').val() + '</textarea></div>';
			// iteration
			var iteration = $('[data-iteration]', $target).get().length;
			html = html.replace(/{{iteration}}/g, iteration);
			$target.append(html);
			$('._toParseFournisseur', $target).each(function(i, el) {
				parseFournisseur(el);
			});
		}
	});


	// modif fournisseur
	$(document).on('input', '.document_thumb [data-name]', function() {
		var $this = $(this);
		var $block = $($this.parents('.document_thumb').get(0));
		var newval = {};
		$('[data-name]', $block).each(function(i, el) {
			newval[$(el).data('name')] = $(el).val();
		});
		$('._toParse_value:eq(0)', $block).val( JSON.stringify(newval) );
	});


	// annulation modifs fournisseur
	/*$(document).on('click', '._cancel_fournisseurmodifs', function(e) {
		e.preventDefault();
		var $this = $(this);
		var $block = $($this.parents('.document_thumb').get(0));
		var val;
		try {
			val = JSON.parse( $('._originalvalue:eq(0)', $block).val() );
		}
		catch(e) {
			val = {};
		}
		for(var key in val)
			$('[data-name="' + key + '"]', $block).val(val[key]);
		$('._toParse_value:eq(0)', $block).val( $('._originalvalue:eq(0)', $block).val() );
		$('.alert', $block).remove();
	});*/


	function parseFournisseur(el) {
		var val;
		try {
			val = JSON.parse( $('._toParse_value:eq(0)', el).val() );
		}
		catch(e) {
			val = {};
		}

		var content = $('#block_fournisseur').html();

		// add random string to ids
		var random_str = Math.floor((Math.random() * 100000000) + 1).toString();
		content = content.replace(/(id|for)="(.+?)"/g, '$1="$2' + random_str + '"');
		
		var template = $('<div class="card card-fournisseur">' + 
			'<div class="card-header d-flex justify-content-between">' + 
				'<a data-toggle="collapse" href="#fournisseur_body_' + random_str + '"><span class="font-weight-bold mr-2">' + val.nom + '</span><span class="categorie mr-1 text-muted"></span><span class="material-icons">arrow_drop_down</span><span class="material-icons d-none">arrow_drop_up</span></a>' + 
				'<a data-remove class="text-danger" href="#" title="' + __str('Supprimer') + '"><i class="material-icons">clear</i></a>' + 
			'</div>' + 
			'<div class="card-body collapse" id="fournisseur_body_' + random_str + '">' + 
				content + 
			'</div>' + 
		'</div>');

		for(var key in val)
			$('[data-name="' + key + '"]', template).val(val[key]);

		// categorie in title
		if( $('[data-name="categorie"]', template).val() != '' ) {
			$('.categorie', template).html('(' + $('[data-name="categorie"] option[value="' + $('[data-name="categorie"]', template).val() + '"]', template).text() + ')');
		}

		$(el).append(template).removeClass('_toParseFournisseur');
	}

	// fournisseur collapse
	$('#zone_fournisseurs').on('show.bs.collapse hide.bs.collapse', '.card-body', function() {
		var $this = $(this);
		var fournisseur = $this.parents('.card-fournisseur').get(0);
		$('[data-toggle="collapse"][href="#' + $this.attr('id') + '"] .material-icons', fournisseur).toggleClass('d-none');
	});

	// fournisseur xhange category in title
	$('#zone_fournisseurs').on('change', '[data-name="categorie"]', function() {
		var $this = $(this);
		var fournisseur = $this.parents('.card-fournisseur').get(0);
		$('.categorie', fournisseur).html('(' + $('[data-name="categorie"] option[value="' + $this.val() + '"]', fournisseur).text() + ')');
	});


	$(function() {
		$('._toParseFournisseur').each(function(i, el) {
			parseFournisseur(el);
		});
	});

	/*
	 * parse URL iframe field
	 */
	$('#frm_programme_iframe').on('input', function() {
		var $this = $(this);
		var url = $this.val().match(/(http:[^\s'"]+)/);
		if( url ) {
			$this.val(url[0]);
			$('._preview_iframe').prop('disabled', false);
		}
		else
			$('._preview_iframe').prop('disabled', true);
	}).trigger('input');

	$('._preview_iframe').on('click', function() {
		$.fancybox.open({
			src  : $('#frm_programme_iframe').val(),
			type : 'iframe'
		});
	});

}

/*
 * formulaire lot
 */

// formulaire lot -> typeahead
$(document).on('lightbox:show', function(e) {
	$('._lot_plus_typeahead', e.target).typeahead({
		hint: false,
		highlight: true,
		minLength: 0,
		showHintOnFocus: true,
		fitToElement: true,
		source: ['Terrasse', 'Cour', 'Balcon', 'Jardin', 'Parking int', 'Parking ext', 'Garage', 'Cave']
	});
});
$(document).on('addblock:new', function(e) {
	$('._lot_plus_typeahead', e.target).typeahead({
		hint: false,
		highlight: true,
		minLength: 0,
		showHintOnFocus: true,
		fitToElement: true,
		source: ['Terrasse', 'Cour', 'Balcon', 'Jardin', 'Parking int', 'Parking ext', 'Garage', 'Cave']
	});
});

// formulaire lot calcul ht
$(document).on('input', '[data-calcht][data-tva]', function() {
	var $this = $(this);
	var $ht_field = $($this.data('calcht'));
	var tva = parseFloat( getPrixFormat($this.data('tva')) );
	var ttc = parseFloat( getPrixFormat($this.val()) );
	if( isNaN(ttc) ) {
		$ht_field.html('');
		return false;
	}
	$ht_field.html( prixFormat( Math.round(ttc / (1 + tva / 100) * 100) / 100 ) + ' €');
});


// si type terrain -> TVA manuelle et plus de calcul auto
$(document).on('change', '#frm_lot_type', function() {
	if( $(this).val() == _LOT_TYPE_TERRAIN ) {
		$('.tva_normal').addClass('d-none');
		$('.tva_terrain').removeClass('d-none');
	}
	else {
		$('.tva_normal').removeClass('d-none');
		$('.tva_terrain').addClass('d-none');
	}
});


// formulaire lot change frm_lot_prix_base_ht
$(document).on('input', '#frm_lot_prix_base_ht', function() {
	if( $('#frm_lot_type').val() != _LOT_TYPE_TERRAIN ) {
		var $this = $(this);
		var ht = parseFloat(getPrixFormat($this.val()));
		var tva = parseFloat(getPrixFormat($('#frm_lot_prix_base_tva').val()));
		if( !isNaN(ht) && !isNaN(tva) ) {
			$('#frm_lot_prix_base_tva_montant').html(prixFormat(Math.round(ht * tva / 100 * 100) / 100 ) + ' €');
			$('#frm_lot_prix_base_ttc').val(prixFormat(Math.round(ht * (1 + tva / 100) * 100) / 100 ) + ' €');
		}
		else {
			$('#frm_lot_prix_base_tva_montant').html('');
			$('#frm_lot_prix_base_ttc').val('');
		}
		$('#frm_lot_prix_remise_pourcent').trigger('change');
	}
});

// formulaire lot change frm_lot_prix_base_tva
$(document).on('change', '#frm_lot_prix_base_tva', function() {
	if( $('#frm_lot_type').val() != _LOT_TYPE_TERRAIN ) {
		var $this = $(this);
		var tva = parseFloat(getPrixFormat($this.val()));
		var ht = parseFloat(getPrixFormat($('#frm_lot_prix_base_ht').val()));
		var ttc = parseFloat(getPrixFormat($('#frm_lot_prix_base_ttc').val()));
		if( !isNaN(ht) && !isNaN(tva) ) {
			$('#frm_lot_prix_base_tva_montant').html(prixFormat(Math.round(ht * tva / 100 * 100) / 100 ) + ' €');
			$('#frm_lot_prix_base_ttc').val(prixFormat(Math.round(ht * (1 + tva / 100) * 100) / 100 ) + ' €');
		}
		else if( !isNaN(ttc) && !isNaN(tva) ) {
			$('#frm_lot_prix_base_ht').val(prixFormat(Math.round(ttc / (1 + tva / 100) * 100) / 100 ) + ' €');
			$('#frm_lot_prix_base_tva_montant').html(prixFormat(Math.round((ttc - ttc / (1 + tva / 100)) * 100) / 100 ) + ' €');
		}
		else {
			$('#frm_lot_prix_base_tva_montant').html('');
			$('#frm_lot_prix_base_ttc').val('');
			$('#frm_lot_prix_base_ht').val('');
		}
		$('#frm_lot_prix_remise_pourcent').trigger('change');
	}
});

// formulaire lot change frm_lot_prix_base_ttc
$(document).on('input', '#frm_lot_prix_base_ttc', function() {
	if( $('#frm_lot_type').val() != _LOT_TYPE_TERRAIN ) {
		var $this = $(this);
		var ttc = parseFloat(getPrixFormat($this.val()));
		var tva = parseFloat(getPrixFormat($('#frm_lot_prix_base_tva').val()));
		if( !isNaN(ttc) && !isNaN(tva) ) {
			$('#frm_lot_prix_base_ht').val(prixFormat(Math.round(ttc / (1 + tva / 100) * 100) / 100 ) + ' €');
			$('#frm_lot_prix_base_tva_montant').html(prixFormat(Math.round((ttc - ttc / (1 + tva / 100)) * 100) / 100 ) + ' €');
		}
		else {
			$('#frm_lot_prix_base_tva_montant').html('');
			$('#frm_lot_prix_base_ht').val('');
		}
		$('#frm_lot_prix_remise_pourcent').trigger('change');
	}
});

// formulaire lot change frm_lot_prix_remise_pourcent
$(document).on('change', '#frm_lot_prix_remise_pourcent', function() {
	var $this = $(this);
	var remise = parseFloat(getPrixFormat($this.val()));
	var ttc = parseFloat(getPrixFormat($('#frm_lot_prix_base_ttc').val()));
	if( !isNaN(ttc) && !isNaN(remise) ) {
		$('#frm_lot_prix_remise_montant').html(prixFormat(Math.round(ttc * + remise / 100 * 100) / 100 ) + ' €');
		$('#frm_lot_prix_remise_ttc').html(prixFormat(Math.round((ttc * (1 - remise / 100)) * 100) / 100 ) + ' €');
	}
	else {
		$('#frm_lot_prix_remise_montant').html('');
		$('#frm_lot_prix_remise_ttc').html('');
	}
});

// formulaire lot change frm_lot_prix_vente_ht
$(document).on('input', '#frm_lot_prix_vente_ht', function() {
	if( $('#frm_lot_type').val() != _LOT_TYPE_TERRAIN ) {
		var $this = $(this);
		var ht = parseFloat(getPrixFormat($this.val()));
		var tva = parseFloat(getPrixFormat($('#frm_lot_prix_vente_tva').val()));
		if( !isNaN(ht) && !isNaN(tva) ) {
			$('#frm_lot_prix_vente_tva_montant').html(prixFormat(Math.round(ht * tva / 100 * 100) / 100 ) + ' €');
			$('#frm_lot_prix_vente_ttc').val(prixFormat(Math.round(ht * (1 + tva / 100) * 100) / 100 ) + ' €');
		}
		else {
			$('#frm_lot_prix_vente_tva_montant').html('');
			$('#frm_lot_prix_vente_ttc').val('');
		}
	}
});

// formulaire lot change frm_lot_prix_vente_tva
$(document).on('change', '#frm_lot_prix_vente_tva', function() {
	if( $('#frm_lot_type').val() != _LOT_TYPE_TERRAIN ) {
		var $this = $(this);
		var tva = parseFloat(getPrixFormat($this.val()));
		var ht = parseFloat(getPrixFormat($('#frm_lot_prix_vente_ht').val()));
		var ttc = parseFloat(getPrixFormat($('#frm_lot_prix_vente_ttc').val()));
		if( !isNaN(ht) && !isNaN(tva) ) {
			$('#frm_lot_prix_vente_tva_montant').html(prixFormat(Math.round(ht * tva / 100 * 100) / 100 ) + ' €');
			$('#frm_lot_prix_vente_ttc').val(prixFormat(Math.round(ht * (1 + tva / 100) * 100) / 100 ) + ' €');
		}
		else if( !isNaN(ttc) && !isNaN(tva) ) {
			$('#frm_lot_prix_vente_ht').val(prixFormat(Math.round(ttc / (1 + tva / 100) * 100) / 100 ) + ' €');
			$('#frm_lot_prix_vente_tva_montant').html(prixFormat(Math.round((ttc - ttc / (1 + tva / 100)) * 100) / 100 ) + ' €');
		}
		else {
			$('#frm_lot_prix_vente_tva_montant').html('');
			$('#frm_lot_prix_vente_ttc').val('');
			$('#frm_lot_prix_vente_ht').val('');
		}
	}
});

// formulaire lot change frm_lot_prix_vente_ttc
$(document).on('input', '#frm_lot_prix_vente_ttc', function() {
	if( $('#frm_lot_type').val() != _LOT_TYPE_TERRAIN ) {
		var $this = $(this);
		var ttc = parseFloat(getPrixFormat($this.val()));
		var tva = parseFloat(getPrixFormat($('#frm_lot_prix_vente_tva').val()));
		if( !isNaN(ttc) && !isNaN(tva) ) {
			$('#frm_lot_prix_vente_ht').val(prixFormat(Math.round(ttc / (1 + tva / 100) * 100) / 100 ) + ' €');
			$('#frm_lot_prix_vente_tva_montant').html(prixFormat(Math.round((ttc - ttc / (1 + tva / 100)) * 100) / 100 ) + ' €');
		}
		else {
			$('#frm_lot_prix_vente_tva_montant').html('');
			$('#frm_lot_prix_vente_ht').val('');
		}
	}
});


// formulaire lot calcul rentabilite
$(document).on('input', '[data-calcrentabilite][data-loyer][data-prix]', function() {
	var $this = $(this);
	var $rentabilite_field = $($this.data('calcrentabilite'));
	var loyer = parseFloat( getPrixFormat($($this.data('loyer')).val()) );
	var ttc = parseFloat( getPrixFormat($($this.data('prix')).val()) );
	if( isNaN(ttc) || isNaN(loyer) ) {
		$rentabilite_field.html('');
		return false;
	}
	$rentabilite_field.html( prixFormat( Math.round(loyer * 12 / ttc * 100 * 100) / 100 ) + ' %');
});


/*
 * formulaire lot toggle eligibilite et fiscalite
 */
$(document).on('change', '[data-disable-target]', function() {
	var $this = $(this);
	var $target = $($this.data('disable-target'));
	$target.attr('disabled', !$this.prop('checked'));
});



/*
 * validation du formulaire lot
 */ 
$(document).on('click', '#frm_lot button[name="action"][value="lotsadd"], #frm_lot button[name="action"][value="lotsmodify"]', function(e) {
	e.preventDefault();

	var $this = $(this);
	var $frm = $($this.parents('form')[0]);

	var valid = true;

	if( $frm[0].checkValidity() === false )
		valid = false;

	$frm.addClass('was-validated');
	fixBootstrapSelectValidation();

	if( !valid ) {
		if( $('.form-group *:invalid', $frm).get().length ) {
			// si pas de champ invalide visible -> on change la langue pour le premier champ invalide invisible
			if( !$('.form-group *:invalid:visible', $frm).get().length ) {
				$('.lang_selector .btn[data-lang="' + $($('.form-group *:invalid:hidden', $frm).parents('.form-group')).data('lang') + '"]').click();
			}
			//on scrolle jusqu'au premier champ invalide
			var pos = $($('.form-group *:invalid:visible:eq(0)', $frm).parents('.form-group')[0]).offset().top;
			var pos2 = $($('.form-group *:invalid:visible:eq(0)', $frm).parents('form')[0]).offset().top;
			$('.fancybox-container.fancybox-is-open .fancybox-slide--current').animate({scrollTop: pos - pos2 }, 10);
			$('.form-group *:invalid:visible:eq(0)', $frm).focus();
		}
	}
	else {
		$.ajax({
			type: "POST",
			url: $frm.attr('action'),
			dataType: 'json',
			data: $frm.serialize() + '&action=' + $this.val()
		}).done(function(data) {
			if( data.success ) {
				$('#lots_list').html(data.content);
				$.fancybox.close();
				$('html, body').animate({scrollTop: $('#lots_list').offset().top }, 10);
			}
			else {
				$.fancybox.getInstance().setContent( $.fancybox.getInstance().current, data.content );
			}
		});
	}
});


/*
 * action au toggle lot
 */
$(document).on('toggle:change', function(e) {
	var $this = $(e.target);
	// on affiche ou non la case d'état du lot
	var $case = $('.case-etat', $this.parents('tr')[0]);
	if( $this.hasClass('text-success') )
		$case.removeClass('invisible');
	else
		$case.addClass('invisible');
});


// tri de la liste des lots
$('#lots_list').on('click', '.sort', function(e) {
	e.preventDefault();
	var $this = $(this);
	$('#lots_list').load( $this.attr('href') );
});


/*
 * suppression lot
 */
$(document).on('click', '[name="action"][value="lotsdelete"][data-lotsdelete][data-url]', function() {
	var $this = $(this);
	$.ajax({
		type: "POST",
		url: $this.data('url'),
		data: { action: 'lotsdelete', lotsdelete: $this.data('lotsdelete') }
	}).done(function(data) {
		if( $this.data('origine') == 'stock' )
			$('#main').html(data);
		else
			$('#lots_list').html(data);
	});
});


/*
 * clonage lot
 */
$(document).on('click', '[name="action"][value="lotsclone"][data-lotsclone][data-url]', function() {
	var $this = $(this);
	$.ajax({
		type: "POST",
		url: $this.data('url'),
		data: { action: 'lotsclone', lotsclone: $this.data('lotsclone') }
	}).done(function(data) {
		$('#lots_list').html(data);
	});
});
